import TextField from '@material-ui/core/TextField';
import { AxiosError } from 'axios';
import * as React from 'react';
import type { Avatar } from '../actions/getInitData';
import api from '../api/api';
import { ReactComponent as MemberIcon } from '../icons/member.svg';
import useStore from '../store/store';
import AvatarImage from './AvatarImage';
import Dialog from './Dialog';

interface EditProfileProps {
    open: boolean;
    onClose: () => void;
}

interface Profile {
    institution?: string;
    avatarId?: number;
}

const EditProfileForm = ({ open, onClose }: EditProfileProps) => {
    const profile = useStore((state) => state.profile);
    const { setFormError, setLoading, setProfile, defaultAvatars } =
        useStore.getState();
    const [selectedAvatar, setSelectedAvatar] = React.useState(() => {
        const parsed = Number.parseInt(profile.avatarId ?? '', 10);
        return Number.isNaN(parsed)
            ? (defaultAvatars[0]?.DefaultAvatarId ?? 1)
            : parsed;
    });

    const update = async (params: Profile) => {
        setLoading(true);
        try {
            const response = await api.post('/user/update-profile', params);
            const { success, errCode } = response.data;
            if (success) {
                setProfile({ ...profile, ...params } as Profile);
                setLoading(false);
            } else if (!success && errCode) {
                setFormError(errCode);
                setLoading(false);
            }
        } catch (e: unknown) {
            if (e instanceof AxiosError) {
                console.error(e.response?.data);
                setFormError(e.code ?? 'other');
            } else {
                setFormError('other');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();

        const target = e.target as typeof e.target & {
            institution: { value: string };
        };
        const institution = target.institution?.value.trim();

        update({
            institution,
            avatarId: selectedAvatar,
        });
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            title="Edit Profile"
            icon={<MemberIcon />}
        >
            <TextField
                margin="dense"
                id="institution"
                name="institution"
                label="Institution"
                type="text"
                fullWidth
                variant="outlined"
                defaultValue={profile?.institution || ''}
                inputProps={{
                    maxLength: 100,
                }}
            />

            <p style={{ marginTop: '20px' }}>Choose Background Picture:</p>
            <div>
                {defaultAvatars.map((avatar: Avatar) => (
                    <AvatarImage
                        filePath={avatar.FilePath}
                        style={{
                            cursor: 'pointer',
                            margin: '10px',
                            border:
                                avatar.DefaultAvatarId === selectedAvatar
                                    ? `3px solid #000`
                                    : `3px solid #00000000`,
                        }}
                        width={200}
                        onClick={() =>
                            setSelectedAvatar(avatar.DefaultAvatarId)
                        }
                        key={avatar.DefaultAvatarId}
                        alt="avatar"
                    />
                ))}
            </div>
        </Dialog>
    );
};

export default EditProfileForm;
